import { render } from "./RelationshipLists.vue?vue&type=template&id=614f843a"
import script from "./RelationshipLists.vue?vue&type=script&lang=js"
export * from "./RelationshipLists.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__